






















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Mutation, namespace } from 'vuex-class';
import { setTimeout } from 'timers';

@Component({})
export default class StepForm2 extends Vue {

  @Prop({ type: Object, default: () => {} })
  private value!: any;

  private form: any = null;

  private data: any = {};

  private formItemLayout = {
    labelCol: {
      span: 5,
    },
    wrapperCol: {
      span: 19,
    },
  };

  private submitting: boolean = false;


  constructor() {
    super();
  }

  private onValidateForm(e: any) {
      e.preventDefault();
      this.form.validateFields((err: any, values: any) => {
        if (!err) {
          this.submitting = true;
          setTimeout(() => {
            this.value.step = 2;
            this.submitting = false;
          }, 1000);
        }
      });
    }

    private onPrev() {
      this.value.step = 0;
    }

    private mounted(): void {
    this.data = this.value;
  }

}
